import { render, staticRenderFns } from "./VmsList.vue?vue&type=template&id=22fa7383&scoped=true&"
import script from "./VmsList.vue?vue&type=script&lang=js&"
export * from "./VmsList.vue?vue&type=script&lang=js&"
import style0 from "./VmsList.vue?vue&type=style&index=0&id=22fa7383&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fa7383",
  null
  
)

export default component.exports